<!-- App.vue -->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { createRouter, createWebHistory } from 'vue-router';
import mainCard from './components/mainCard.vue';
import projectCard from './components/projectCard.vue';
import research from './components/research.vue';

const routes = [
  { path: '/', component: mainCard },
  { path: '/projects', component: projectCard },
  { path: '/research', component: research }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default {
  name: 'App',
  setup() {
    return { router };
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
  background: #0d0d12;
}
body {
  margin: 0;
  min-width: 320px;
  background-color: #0d0d12;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
</style>
